import {
  FETCH_SURVEY_LIST_REQUEST,
  FETCH_SURVEY_LIST_SUCCESS,
  FETCH_SURVEY_LIST_FAILURE,
  FETCH_SURVEY_DETAIL_REQUEST,
  FETCH_SURVEY_DETAIL_SUCCESS,
  FETCH_SURVEY_DETAIL_FAILURE,
  FETCH_USER_SURVEY_LIST_REQUEST,
  FETCH_USER_SURVEY_LIST_SUCCESS,
  FETCH_USER_SURVEY_LIST_FAILURE,
} from "../actions/surveyActions";

const initialState = {
  loading: false,
  surveyList: [],
  userSurveyList: [],
  surveyDetail: null,
  error: null,
};

const surveyReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SURVEY_LIST_REQUEST:
    case FETCH_SURVEY_DETAIL_REQUEST:
    case FETCH_USER_SURVEY_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_SURVEY_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        surveyList: action.payload,
      };

    case FETCH_USER_SURVEY_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        userSurveyList: action.payload,
      };

    case FETCH_SURVEY_DETAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        surveyDetail: action.payload,
      };

    case FETCH_SURVEY_LIST_FAILURE:
    case FETCH_SURVEY_DETAIL_FAILURE:
    case FETCH_USER_SURVEY_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default surveyReducer;
